import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
// import AddPalletesationTables from "../tables/AddPalletesationTable";
import { useFormik, FormikProvider } from "formik";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const BankAccountTransactionEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});

  const [backendErrors, setBackendErrors] = useState([]);
  const [bankLists, setBankLists] = useState([]);
  const [typeLists, setTypeLists] = useState([]);
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const [currencySymbol, setCurrencySymbol] = useState('dh');
    let season_id = localStorage.getItem("season_id");

  const transacionList = ([
    { value: 'DEBIT', label: "DEBIT" },
    { value: 'CREDIT', label: "CREDIT" },
  ]);
      
    const primaryCurrency =  [
      {
          "label": "EUR",
          "value": 1,
          "symbol": "€",
          "key": "cabrane-0"
      },
      {
          "label": "USD",
          "value": 2,
          "symbol": "$",
          "key": "cabrane-1"
      },
      {
          "label": "GBP",
          "value": 3,
          "symbol": "£",
          "key": "cabrane-2"
      },
      {
          "label": "MAD ",
          "value": 4,
          "symbol": "dh",
          "key": "cabrane-3"
      }
  ];
  const formik = useFormik({
    initialValues: {
      id: value.id,
      season_id:season_id,
      bank:value.bank,
      transaction_date: value.transaction_date,
      expense_type: value.expense_type,
      transaction_amount: value.transaction_amount,
      transaction_type:value.transaction_type,  
      currency:value.currency,
      note:value.note,
      paid_to:value.paid_to
    },
    enableReinitialize: true,
    //validationSchema: EditUserSchema,
    onSubmit: (values , { setSubmitting }) => {
      axios
        .post("/bank-account-transactions/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
         
          delete backendErrors['error'];
          setSubmitting(false);
          // actions.setSubmitting(false);
          $("#form-submit").text("Update Transaction");
           if (response.data.code === 200) {
            
             toast.success(response.data.message);
          //   actions.resetForm();
             setTimeout(() => {
               window.location.href = "/bank-account-transactions";
             }, 1000);
           }  else if (response.data.code === 422) {
               setBackendErrors(response.data.error);
           }
           else if (response.data.code === 401) {
             setBackendErrors(response.data.error);
           }
           else {
              setBackendErrors(response.data.error);
           }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  useEffect(() => {
        setPermission(FindModuleById(446)); 
console.log(permission);

  

    axios
    .get(`/helper/banks-list2`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      if (response.data.code === 200) {
        let types = response.data.data.banks;
        let typeslisting = types.map((ord, index) => ({
          label: ord.title,
          value: ord.id,
          key: `location-${index}`,
        }));
        setBankLists(typeslisting);
      } else {
        console.log("API response is not an array");
      }
    }).catch((error) => {
      console.log(error);
    });


    axios
      .get(`/bank-account-transactions/edit/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
         setValue(response.data.data.expense);
         const currencydetail = primaryCurrency.find(item => item.value === response.data.data.expense.currency) || null;
          setCurrencySymbol(currencydetail ? currencydetail.symbol : 'dh');
  
        }
      })
      .catch((error) => {
        console.log(error);
      });
    
  }, [id]);



  
  useEffect(() => {
    axios
    .get(`/helpers/expenses-types`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    })
    .then((response) => {
      if (response.data.code === 200) {
        let types = response.data.data.types;
        let typeslisting = types.map((ord, index) => ({
          label: ord.title,
          value: ord.id,
          key: `location-${index}`,
        }));
        setTypeLists(typeslisting);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });
   

    
}, []);

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  
  const customFuction = (event) =>{
    console.log(event);
    setCurrencySymbol(event.symbol)
  }

  
  const customHandleStatus = (event) =>{
    const val = event.target.value;
    if(val =='CREDIT'){  
      $(".expense_type_hiv").hide();
    }else{
      $(".expense_type_hiv").show();
    }
}

const handleSelectChange = (name, selectedOption) => {
  const value = selectedOption ? selectedOption.value : "";
  updateFormikValue(name, value);
  customHandleInput({ target: { name, value } });
};

const updateFormikValue = (name, value) => {
  formik.setFieldValue(name, value);
};
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Expense</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/expenses">Expenses</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>
            {permission && permission.add == 1 && (

            <FormikProvider value={formik}>
                      <form onSubmit={formik.handleSubmit}>
                     
                      <div className="row">
                        <div className="col-md-12">
                          <div className="card">
                              <div className="card-body">
                                <h4 className="card-title">EXPENSE INFORMATION</h4>
                                <div className="row">


                                  <div className="col-md-6">
                                    <div className="form-group status">
                                        <label>Bank</label>
                                        {bankLists.length > 0 && (
                                          <Select
                                          className="w-100"
                                          value={bankLists.find(option => option.value == formik.values.bank) || null} // Ensure correct format
                                          name="bank"
                                          //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                          onChange={(selectedOption) => {
                                            handleSelectChange("bank", selectedOption);
                                            //customfunction(selectedOption);
                                          }}
                                          onBlur={formik.handleBlur}
                                          options={bankLists}
                                          placeholder="Select"  
                                        />
                                        )}
                                        
                                        <small>
                                          {backendErrors.bank && (
                                              <span className="form-error mt-1">
                                                {backendErrors.bank}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                    </div>

                                  <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Transaction Date</label>
                                        <input
                                          type="date"
                                          name="transaction_date"
                                          value={formik.values.transaction_date}
                                          className="form-input form-control"
                                          onChange={(e) => {
                                            formik.handleChange(e);
                                            customHandleInput(e);
                                            //setDefaultDate(e.target.value)
                                          }}
                                          onBlur={formik.handleBlur}
                                        // defaultValue={defaultDate}

                                        />
                                        <small>
                                          {backendErrors.transaction_date && (
                                              <span className="form-error mt-1">
                                                {backendErrors.transaction_date}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                    </div>

                                    <div className="col-md-6 ">
                                    <div className="form-group ">
                                        <label>Paid To</label>
                                        <input
                                          type="text"
                                          name="paid_to"
                                          value={formik.values.paid_to}
                                          className="form-input form-control"
                                          onChange={(e) => {
                                            formik.handleChange(e);
                                            customHandleInput(e);
                                          }}
                                          onBlur={formik.handleBlur}
                                        />
                                        <small>
                                          {backendErrors.paid_to && (
                                              <span className="form-error mt-1">
                                                {backendErrors.paid_to}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                    </div>

                                    <div className="col-md-6">
                                      <div className="form-group status2">
                                        <label>Select Currency</label>
                                        <Select
                                          className="w-100"
                                          value={primaryCurrency.find(option => option.value == formik.values.currency) || null} // Ensure correct format
                                          name="currency"
                                          //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                          onChange={(selectedOption) => {
                                            handleSelectChange("currency", selectedOption);
                                            customFuction(selectedOption);
                                          }}
                                          onBlur={formik.handleBlur}
                                          options={primaryCurrency}
                                          placeholder="Select"  

                                       
                                        />
                                        <small>
                                          {backendErrors.currency && (
                                              <span className="form-error mt-1">
                                                {backendErrors.currency}
                                              </span>
                                            )}
                                        </small>
                                        </div>
                                      
                                      </div>
                                    <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Transaction Amount</label>
                                    
                                  <div className="input-group">
                                            <input 
                                             type="text"
                                             onKeyPress={(event) => {
                                               // Allow only numbers (0-9)
                                               if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                event.preventDefault();
                                              }
                                             }}
                                            name="transaction_amount"
                                            value={formik.values.transaction_amount}
                                            onChange={(e) => {
                                              formik.handleChange(e);
                                              customHandleInput(e);
                                            }}
                                              onBlur={formik.handleBlur}
                                            className="form-control" placeholder="Transaction Amount" aria-label="Transaction Amount" aria-describedby="basic-addon2" />
                                            <div className="input-group-append">
                                                <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                            </div>
                                        </div>


                                        <small>
                                          {backendErrors.transaction_amount && (
                                              <span className="form-error mt-1">
                                                {backendErrors.transaction_amount}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                    <div className="form-group status">
                                        <label>Transaction Type</label>
                                        {transacionList.length > 0 && (
                                          <Select
                                          className="w-100"
                                           value={transacionList.find(option => option.value == formik.values.transaction_type) || null} // Ensure correct format
                                           name="transaction_type"
                                           //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                           onChange={(selectedOption) => {
                                             handleSelectChange("transaction_type", selectedOption);
                                             customHandleStatus(selectedOption);
                                            // customHandleStatus(e);
                                           }}
                                           onBlur={formik.handleBlur}
                                           options={transacionList}
                                           placeholder="Select"  
                                        />
                                        )}
                                        
                                        <small>
                                          {backendErrors.transaction_type && (
                                              <span className="form-error mt-1">
                                                {backendErrors.transaction_type}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                    </div>

                                    <div className="col-md-6 expense_type_hiv">
                                    <div className="form-group status">
                                        <label>Expense Type</label>
                                        {typeLists.length > 0 && (
                                          <Select
                                          className="w-100"
                                          value={typeLists.find(option => option.value == formik.values.expense_type) || null} // Ensure correct format
                                          name="expense_type"
                                          //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                          onChange={(selectedOption) => {
                                            handleSelectChange("expense_type", selectedOption);
                                            //customfunction(selectedOption);
                                          }}
                                          onBlur={formik.handleBlur}
                                          options={typeLists}
                                          placeholder="Select" 
                                        />
                                        )}
                                        
                                        <small>
                                          {backendErrors.expense_type && (
                                              <span className="form-error mt-1">
                                                {backendErrors.expense_type}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                    </div>
                                  
                                    <div className="col-md-12 ">
                                    <div className="form-group ">
                                        <label>Note</label>
                                        <input
                                          type="text"
                                          name="note"
                                          value={formik.values.note}
                                          className="form-input form-control"
                                          onChange={(e) => {
                                            formik.handleChange(e);
                                            customHandleInput(e);
                                          }}
                                          onBlur={formik.handleBlur}
                                        />
                                        <small>
                                          {backendErrors.note && (
                                              <span className="form-error mt-1">
                                                {backendErrors.note}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                              </div>
                          </div>
                        </div>
                      </div>
                   
                      <div className="row">
                        <div className="col-md-12">
                          <div className="card">
                              <div className="card-body">
                                <div className="text-end mt-4">
                                  <button className="btn btn-primary" type="submit" id="form-submit"  disabled={formik.isSubmitting}>
                                  Update Transaction
                                  </button>
                              </div>
                              </div>
                          </div>
                        </div>
                      </div>
                                
                        
                      </form>
                    </FormikProvider>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default BankAccountTransactionEdit;
